/**
 * @ Author: mzc
 * @ Create Time: 2024-07-03 19:51:46
 * @ Modified by: mzc
 * @ Modified time: 2024-07-04 20:31:50
 * @ Description: 购物车
 */
import dayjs from "dayjs";

const initalState = {
	option: {
		page: 1,
		pageSize: 20,
		keyword: ""
	},
	selectedRowKeys: []
};
const shoppingCartReducer = (state = initalState, action) => {
	switch (action.type) {
		case "SHOPPINGCART_UPDATE_OPTION":
			return { ...state, option: { ...action.payload } };
		case "SHOPPINGCART_UPDATE_SELECTEDROWKEYS":
			return { ...state, selectedRowKeys: [...action.payload] };
		case "SHOPPINGCART_RESET":
			return { ...JSON.parse(JSON.stringify(initalState)) };
		default:
			return state;
	}
};

export default shoppingCartReducer;
